var $ = require('../../modules/$');
module.exports = function create(P, D){
  return $.create(P, D);
};


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-runtime/~/core-js/library/fn/object/create.js
 ** module id = 442
 ** module chunks = 0 1 2 3 10 11 12 17 19 20
 **/